import { IconButton } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { BlockClicks } from "lib/@components/block-clicks"

export function AmendsButton({ onClick, disabled }) {
    return (
        <BlockClicks>
            <IconButton
                color="primary"
                size="small"
                aria-label="Add amends"
                data-cy="amends-button"
                onClick={onClick}
                disabled={disabled}
            >
                <Iconify icon="iconoir:chat-plus-in" />
            </IconButton>
        </BlockClicks>
    )
}
